import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Operation } from '../../models/operation.model';
import { PermissionHelper } from '../../helpers/permission.helper';

@Component({
  standalone: false,
  selector: 'app-operation',
  templateUrl: './operation.component.html',
})
export class OperationComponent {
  @Input() operation: Operation;
  @Input() isSelected: boolean;
  @Input() userSectors: Array<string>;
  @Input() isOperationExpanded: boolean;
  @Output() readonly deleteOperation = new EventEmitter();
  @Output() readonly selectOperation = new EventEmitter();

  isCollapsed: boolean = false;

  constructor(public permissionHelper: PermissionHelper) {}

  onExpandOperation(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  onDeleteOperation(operationId: string): void {
    this.deleteOperation.emit(operationId);
  }

  onSelectOperation(operation: Operation): void {
    this.selectOperation.emit(operation);
  }
}
